export const API_CONFIG = {
  // Use empty base; paths in code already start with /api/ (proxied by Nginx)
  BASE_URL: process.env.REACT_APP_API_URL || '',
  TENANT_ID: 'default',
  HEADERS: {
    // Do NOT set global 'Content-Type' to avoid breaking multipart uploads
    'Accept': 'application/json',
    'Fineract-Platform-TenantId': 'default'
  }
}; 

export const RATES_API = {
  USD_TO_ZIG: '/api/rates/usd-to-zig'
};